import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay } = FiIcons;

const Logo = ({ size = 'default' }) => {
  const sizes = {
    small: { container: 'w-8 h-8', text: 'text-lg', play: 'text-sm' },
    default: { container: 'w-11 h-11', text: 'text-2xl', play: 'text-lg' },
    large: { container: 'w-16 h-16', text: 'text-3xl', play: 'text-2xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-3 group cursor-pointer">
      {/* Logo Icon - VR with Play */}
      <div className={`${s.container} rounded-xl bg-gradient-to-br from-brand-neon via-brand-electric to-brand-mint flex items-center justify-center shadow-[0_0_30px_rgba(0,229,255,0.4)] group-hover:shadow-[0_0_50px_rgba(124,58,237,0.6)] transition-all duration-500 relative overflow-hidden animate-gradient border-2 border-brand-electric/50`}>
        {/* Animated shine effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
        
        {/* VR Letters with Play Button */}
        <div className="relative w-full h-full flex items-center justify-center">
          {/* VR Text */}
          <div className="relative flex items-center justify-center font-heading font-black text-white tracking-tighter drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]">
            <span className="relative z-10">V</span>
            <div className="relative -mx-0.5">
              {/* Play button integrated into R */}
              <SafeIcon icon={FiPlay} className={`${s.play} relative z-10`} style={{ marginLeft: '1px' }} />
            </div>
            <span className="relative z-10">R</span>
          </div>
        </div>
      </div>
      
      {/* Text Logo */}
      <div className="font-heading font-bold tracking-tight ${s.text}">
        <span className="text-brand-electric drop-shadow-[0_0_8px_rgba(0,229,255,0.5)]">Vid</span>
        <span className="text-brand-neon drop-shadow-[0_0_8px_rgba(124,58,237,0.5)]">Revive</span>
      </div>
    </div>
  );
};

export default Logo;